<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="itemsPerPage"
      :search="search"
      no-data-text="Sin resultados disponibles"
      class="mx-5"
      dense
      fixed-header
      height="auto"
      :footer-props="{
        'items-per-page-text': 'Elementos por página',
        'items-per-page-all-text': 'Todo',
      }"
      no-results-text="Sin resultados coincidentes con la búsqueda"
      loading-text="Cargando..."
    >
      <template v-slot:[`item.attentionDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.attentionDate) }}
      </template>
      <template v-slot:[`item.actions`]="{ item, index }">
        <v-tooltip top  v-if="$utilFront.withPermission($prm.MODULE_DENTAL_ATTEND)">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="getDataToAttend(item.idMedicalPractice)" small>
              <v-icon v-bind="attrs" v-on="on" color="secondary">
                mdi-doctor
              </v-icon>
            </v-btn>
          </template>
          <span>Atender</span>
        </v-tooltip>
        <v-tooltip top :index="index"  v-if="$utilFront.withPermission($prm.MODULE_DENTAL_CANCEL)">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="checkCancel(item)" color="error" small>
              <v-icon v-bind="attrs" v-on="on"> mdi-stop </v-icon>
            </v-btn>
          </template>
          <span>Cancelar</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogCancelation"
      persistent
      max-width="70%"
      v-if="dialogCancelation"
    >
      <cancelation-modal
        :dataModal="dataModal"
        @closeCancelationDialog="closeCancelationDialog"
        :dialogCancelation="dialogCancelation"
      />
    </v-dialog>
  </div>
</template>

<script>
import MenuCrud from "@/app/components/base/menu/MenuCrud.vue";
import CancelationModal from "@/app/components/common/CancelationModal.vue";

export default {
  name: "SpecialityTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    itemsPerPage: Number,
    listAllPagination: Function,
    search: String,
  },
  components: {
    MenuCrud,
    CancelationModal,
  },
  data() {
    return {
      dialogCancelation: false,
      dataModal: {},
      headers: [
        {
          text: "Id Consulta",
          value: "idMedicalPractice",
          align: "center",
          sortable: false,
        },
        {
          text: "Id Paciente",
          value: "idPatient",
          align: "center",
          sortable: false,
        },
        {
          text: "Nombre del paciente",
          value: "fullNamePatient",
          align: "center",
          sortable: false,
        },
        {
          text: "Fecha y hora de solicitud",
          value: "attentionDate",
          align: "center",
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width: "15%",
        },
      ],
    };
  },
  methods: {
    checkCancel(item) {
      this.dataModal = {};
      this.dataModal = Object.assign(this.dataModal, item);
      this.dataModal.birthDate = this.$utilFront.formatDate(
        this.dataModal.birthDate
      );
      this.dialogCancelation = true;
    },
    closeCancelationDialog(e) {
      this.dialogCancelation = e;
      this.deleteItem();
    },
    getDataToAttend(id) {
      let isViewDetails = false;
      this.$emit("isViewDetails", isViewDetails);
      this.get(id, 2);
    },
  },
};
</script>
